import { styled } from 'stitches.config'

export const RawFoodSubscriptionRoot = styled('div', {
  backgroundColor: '$tertiary-200',
})
